import { render, staticRenderFns } from "./ColorCalibrationBefore.vue?vue&type=template&id=0bfde8f8&scoped=true&"
import script from "./ColorCalibrationBefore.vue?vue&type=script&lang=js&"
export * from "./ColorCalibrationBefore.vue?vue&type=script&lang=js&"
import style0 from "./ColorCalibrationBefore.vue?vue&type=style&index=0&id=0bfde8f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfde8f8",
  null
  
)

export default component.exports